import { toastService } from '../services/ToastService';

export const showErrorToast = (title?: string, message?: string) => {
  toastService.error(message || '', title || '');
};

export const showSuccessToast = (title?: string, message?: string) => {
  toastService.success(message || '', title || '');
};

export const showWarningToast = (title?: string, message?: string) => {
  toastService.warning(message || '', title || '');
};

export const showInfoToast = (title?: string, message?: string) => {
  toastService.info(message || '', title || '');
};

